import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { Component, OnInit } from '@angular/core';
import { ModalService } from 'src/app/shared/services/modal.service';
import { interval } from 'rxjs';
import { take, map } from 'rxjs/operators';

@Component({
  selector: 'current-user',
  templateUrl: './current-user.component.html',
  styleUrls: ['./current-user.component.sass']
})
export class CurrentUserComponent implements OnInit {
  public currentUserService;
  constructor(
    private _currentUserService: CurrentUserService,
    private modal: ModalService
  ) {
    this.currentUserService = _currentUserService;
  }
  timer: any;

  ngOnInit() {
    this._setCountdown();
  }

  public close() {
    this.modal.close();
  }

  public refresh(){
    this.close();
    this.currentUserService.resetSessionTimer();
  }

  public logOut() {
    this.close();
    this.currentUserService.logout();
  }

  private _setCountdown() {
    this.timer = interval(1000).pipe(
      take(300),
      map(x => 300 - x)
    );
  }

}
